/* eslint-disable local-rules/page-boundary-imports */
import ClientId from '~/constants/ClientId';
import HomeNativeCapability from '~/constants/home/nativeCapability';
import SrpNativeCapability from '~/constants/srp/nativeCapability';
import VdpNativeCapability from '~/constants/vdp/nativeCapability';

const NativeAppCapabilities: Partial<Record<ClientId, Record<string, string>>> =
  {
    [ClientId.DISCOVER]: SrpNativeCapability,
    [ClientId.HOME_UI]: HomeNativeCapability,
    [ClientId.SRP_UI]: SrpNativeCapability,
    [ClientId.VDP_UI]: VdpNativeCapability
  };

export default NativeAppCapabilities;
